export default "__VITE_ASSET__CoFYoEsV__"